module.exports = __webpack_public_path__ + "img/mercado-pago.5f342bd1.png";